export const externalRoutes = {
  decalEsp: process.env.SITE_URL,
  privateSite: process.env.PRIVATE_SITE_URL,
};
